/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var App = function () {
    function App() {
        _classCallCheck(this, App);
    }

    _createClass(App, [{
        key: 'init',
        value: function init(_option) {
            this.option = jQuery.extend(true, {
                apiUrl: '',
                selector: '#autoSuggest',
                service: '',
                alias: '',
                submitCallback: function submitCallback(_q) {
                    return console.log('query :', _q, '::: option.submitCallback 설정은 필수 입니다');
                },
                size: 10,
                useDelbtn: false,
                addParam: {}
            }, _option);

            this.loadedKeyword = '';
            this.dataBaseKeyword = '';
            this.isValueFunctionText = '';
            this.apiUrl = this.setApiUrl();
            this.suggestWrap = jQuery(this.option.selector + " [data-name='suggest_wrap']").hide();
            this.input = jQuery(this.option.selector + " [data-name='suggest_input']");
            this.submitBtn = jQuery(this.option.selector + " [data-name='suggest_submit']");
            this.deleteBtn = jQuery(this.option.selector + " [data-name='suggest_delete']").hide();
            this.resultUL = jQuery(this.option.selector + " [data-name='suggest_scroll'] ul");

            this.addEvents();
        }
    }, {
        key: 'setApiUrl',
        value: function setApiUrl() {
            var url = '';
            if (!this.option.apiUrl) {
                var env = location.href.match(/(rc\.|rc\-)/i) ? location.href.match(/(rc\.|rc\-)/i)[1] : 'live';
                env = /local\.|localhost\.|opdev\.|ui-static\.|file:/i.test(location.href) ? 'opdev' : env;
                var apiDomains = {
                    'opdev': 'http://opdev-searchsuggest.plaync.com',
                    'rc.': 'https://rc-searchsuggest.plaync.com',
                    'rc-': 'https://rc-searchsuggest.plaync.com',
                    'live': 'https://searchsuggest.plaync.com'
                };

                url = apiDomains[env] + ('/suggest/' + this.option.service + '/v1.0/' + this.option.alias);
            } else {
                url = this.option.apiUrl;
            }

            return url;
        }
    }, {
        key: 'load',
        value: function load(_newKeyword) {
            var _this = this;

            if (this.ajaxCall && this.ajaxCall.abort) this.ajaxCall.abort();

            this.loadedKeyword = _newKeyword;
            var params = jQuery.extend(true, { query: this.loadedKeyword.replace(/\s*/g, ''), page_size: this.option.size }, this.option.addParam);

            this.ajaxCall = jQuery.ajax({
                url: this.apiUrl,
                xhrFields: { withCredentials: true }, dataType: "json", type: "GET",
                data: jQuery.param(params)
            }).done(function (_data) {
                return _this.drawList(_data);
            }).fail(function (e) {
                return console.log('::::::::::fail::::::::::', e);
            });
        }
    }, {
        key: 'addEvents',
        value: function addEvents() {
            var _this2 = this;

            var eventType = window._device && window._device === 'ingame' ? 'keypress' : 'keydown';
            this.input.on(eventType + '.autoSuggest', function (e) {
                if (e.keyCode === 27) {
                    // ESC
                    _this2.input.val(_this2.loadedKeyword);
                    _this2.suggestWrapToggle(false);
                    return false;
                }

                if (e.keyCode === 13) {
                    // Enter
                    _this2.submitGo();
                    return false;
                }

                if (e.keyCode === 9) {
                    // Tab
                    _this2.focusChange(!e.shiftKey ? 1 : -1);
                    return false;
                }

                if (e.keyCode === 40) {
                    // ↓
                    _this2.focusChange(1);
                    return false;
                }

                if (e.keyCode === 38) {
                    // ↑
                    _this2.focusChange(-1);
                    return false;
                }
            });

            this.input.on('focusout', function (e) {
                setTimeout(function () {
                    return _this2.suggestWrapToggle(false);
                }, 150);
            });

            this.input.on('focusin', function (e) {
                _this2.isValueFunctionText = '';
                if (!_this2.sto) _this2.realTimeInputCheck();
                if (_this2.resultUL.find('li').length) _this2.suggestWrapToggle(true);
            });

            this.submitBtn.on('click', function (e) {
                return _this2.submitGo();
            });

            this.deleteBtn.on('click', function (e) {
                _this2.loadedKeyword = '';
                _this2.input.val('').focus();
            });

            this.resultUL.on('mouseover', 'li', function (e) {
                _this2.resultUL.find('li').removeClass('focus');
                jQuery(e.currentTarget).addClass('focus');
            });
        }
    }, {
        key: 'realTimeInputCheck',
        value: function realTimeInputCheck() {
            var _this3 = this;

            if (this.sto) {
                clearTimeout(this.sto);
                this.sto = null;
            }

            var inputTxt = this.input.val().trim();

            // 문자열이 있나?
            if (inputTxt) {
                // 바로 앞에서 api 호출한 문자열 인가?
                // 화살표 이동을 통해 입력된 문자열 인가?
                if (this.loadedKeyword !== inputTxt && this.dataBaseKeyword !== inputTxt && this.isValueFunctionText !== inputTxt) {
                    this.load(inputTxt);
                    this.isValueFunctionText = '';
                }
            } else {
                if (this.loadedKeyword != '') {
                    setTimeout(function () {
                        if (_this3.input.val().trim()) return;
                        _this3.loadedKeyword = '';
                    }, 10);
                }
                if (this.resultUL.html() != '') {
                    setTimeout(function () {
                        _this3.resultUL.html('');
                        _this3.suggestWrapToggle(false);
                    }, 10);
                }
            }

            this.deleteBtnToggle(inputTxt);
            this.sto = setTimeout(function () {
                return _this3.realTimeInputCheck();
            }, 10);
        }
    }, {
        key: 'deleteBtnToggle',
        value: function deleteBtnToggle() {
            var inputTxt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            if (!this.option.useDelbtn) return false;

            if (inputTxt) {
                if (!this.deleteBtnIsShow) {
                    this.deleteBtn.show();
                    this.deleteBtnIsShow = true;
                }
            } else {
                if (this.deleteBtnIsShow) {
                    this.deleteBtn.hide();
                    this.deleteBtnIsShow = false;
                }
            }
        }
    }, {
        key: 'drawList',
        value: function drawList(_data) {
            if (!this.input.val().trim()) return; // 인풋에 문자열 없으면 데이터가 들어와도 보여주지 않는다.

            this.suggestWrapToggle(_data.front.length > 0);
            this.listRemoveEvent();

            var list = '';
            if (_data.front.length) {
                var reg = new RegExp(this.loadedKeyword, 'i');
                list = _data.front.map(function (item, idx) {
                    var regStr = reg.exec(item.keyword);
                    var str = item.keyword.replace(regStr, '<mark>' + regStr + '</mark>');
                    return '<li data-idx="' + idx + '" data-keyword="' + item.keyword + '">' + str + '</li>';
                }).join('');
            }
            this.resultUL.html(list);
            this.listAddEvent();
        }
    }, {
        key: 'listRemoveEvent',
        value: function listRemoveEvent() {
            jQuery(this.option.selector + " [data-name='suggest_scroll'] ul li").off('click');
        }
    }, {
        key: 'listAddEvent',
        value: function listAddEvent() {
            var _this4 = this;

            jQuery(this.option.selector + " [data-name='suggest_scroll'] ul li").on('click', function (e) {
                _this4.input.val(jQuery(e.currentTarget).data('keyword'));
                _this4.submitGo();
            });
        }
    }, {
        key: 'focusChange',
        value: function focusChange() {
            var _direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var newFocusEl = void 0;
            var oldFocusEl = this.resultUL.find('.focus');

            if (_direction === 1) {
                newFocusEl = oldFocusEl.length ? oldFocusEl.next() : this.resultUL.find('li').first();
            }
            if (_direction === -1) {
                newFocusEl = oldFocusEl.length ? oldFocusEl.prev() : this.resultUL.find('li').last();
            }

            this.resultUL.find('li').removeClass('focus');

            this.suggestWrapToggle(newFocusEl.length > 0);

            if (newFocusEl.length) {
                newFocusEl.addClass('focus');
                this.dataBaseKeyword = newFocusEl.data('keyword');
                this.input.val(this.dataBaseKeyword);
            }
        }
    }, {
        key: 'submitGo',
        value: function submitGo() {
            this.suggestWrapToggle(false);
            if (typeof this.option.submitCallback === 'function' && this.input.val().trim() !== '') {
                this.option.submitCallback(this.input.val().trim());
            }
        }
    }, {
        key: 'suggestWrapToggle',
        value: function suggestWrapToggle() {
            var _isShow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.suggestWrap.toggle(_isShow);
            if (!_isShow) this.resultUL.find('li').removeClass('focus');
        }

        // public ---------------------------------------------------------------------

    }, {
        key: 'changeAddParam',
        value: function changeAddParam(_param) {
            this.option.addParam = _param;
        }
    }, {
        key: 'value',
        value: function value(_txt) {
            this.isValueFunctionText = _txt;
            this.input.val(_txt);
        }
    }]);

    return App;
}();

window.AutoSuggest = App;

exports.default = App;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// AutoSuggest.js